import {createSlice} from '@reduxjs/toolkit';

const initialStateValue = {
    data:[]
}

const sharedSlice = createSlice({
    name: 'Shared',
    initialState: {
        value: initialStateValue,
    },

    reducers: {
        shared : (state,action) =>{
            state.value = action.payload;
        },
    },
});

export const {shared} = sharedSlice.actions

export default sharedSlice.reducer